import React from 'react';
import {
	Link
} from 'react-router-dom';
import {
	connect
} from 'react-redux';
import ReactLoading from 'react-loading';
import StarRatingComponent from 'react-star-rating-component';
import Calendar from 'react-calendar';
import {
	history
} from '../../store/configureStore';
import {
	bindActionCreators
} from 'redux';
import * as appointmentActions from '../../actions/appointmentActions';
// import Modal from 'react-modal';
import {
	confirmAlert
} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as constant from '../../constants/constant';
import moment from 'moment';

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'


import Moment from 'react-moment';
import $ from "jquery";
import { stat } from 'fs';
class BookAppointmentCalendar extends React.Component {
	constructor(props, context) {
		var todayDate = moment.utc(new Date());
		var convertDate = new Date(moment(todayDate).local());
		var currenthour = moment(todayDate).local().format("HH")
		var currentmin = moment(todayDate).local().format("mm")
		super(props, context);
		this.state = {};
		this.state = {
			appointmentDate: convertDate,
			currenthour: currenthour,
			currentmin: currentmin,
			minDate: convertDate,
			specialistAvailability: {},
			specialistAvailabilitySlot: [],
			specialistDetailsCalendar: {},
			appointmentData: {},
			isLoader: true,
			spinner: -1,
			specialistBlockDates: [],
			specialistBlockTimes: [],
			specialistBlockDays: [],
			todayDate: "",
			dayToday: ""
		}
		this.goToAppointmentDetailsPage = this.goToAppointmentDetailsPage.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	componentWillMount() {
		let availabilityId = localStorage.getItem('availabilityId');
		let doctoraddress = localStorage.getItem('doctorAddress');
		let patientId = localStorage.getItem('userId');
		let appointmentDate = this.state.appointmentDate;
		let clinetlocation = localStorage.getItem('clinicCountryZone') ? localStorage.getItem('clinicCountryZone') : 'Europe/London';
		var userlocation = moment.tz.guess();
		// var userlocation = 'Europe/London';
		localStorage.setItem('userlocation', userlocation);
		let appointmentObj = {
		availabilityId: availabilityId,
			appointmentDate: appointmentDate,
			currenthour: this.state.currenthour,
			currentmin: this.state.currentmin,
			doctoraddress: doctoraddress,
			clinetlocation: clinetlocation,
			userlocation: userlocation,
			specialistId: localStorage.getItem('specialistId')
		};
		// let appointmentObj = {
		// 	availabilityId: availabilityId,
		// 	appointmentDate: appointmentDate,
		// 	clinetlocation: clinetlocation,
		// 	userlocation: userlocation
		// };
		this.props.actions.getSpecialistAvailability(appointmentObj, this.props);
		this.props.actions.getSpecialistDetailCalendar(appointmentObj, this.props);
		this.props.actions.getBlockAppointmentDate(appointmentObj, this.props);
	}
	componentDidMount() {
		localStorage.setItem('fromMarketPage', false);
	}
	componentWillReceiveProps(nextProps) {

		// if (nextProps.specialistAvailability.dayAvailability != null) {
		// 	localStorage.setItem('clinicCountryZone', nextProps.specialistAvailability.dayAvailability.availabilityId.contryzone)
		// }
		if (nextProps.specialistBlockDates) {
			this.setState({
				specialistBlockTimes: nextProps.specialistBlockDates.timeBlocked,
				specialistBlockDates: nextProps.specialistBlockDates.dateBlocked,
				specialistBlockDays: nextProps.specialistBlockDates.dayBlocked
			}, () => {

			})
		}

		this.setState({
			specialistAvailability: nextProps.specialistAvailability,
			specialistDetailsCalendar: nextProps.specialistDetailsCalendar,
			isLoader: false
		})
		
		// localStorage.setItem('avaiId', nextProps.specialistAvailability.availabilityId)
	}
	onChange(udatedDate) {
		console.log("+++bookung++>>", udatedDate)
		console.log("+++bookung++>>moment", moment(udatedDate).startOf('day'))
		var selDate = moment.utc(udatedDate);
		console.log("++++booking+>>1", selDate)
		let clinetlocation = localStorage.getItem('clinicCountryZone') ? localStorage.getItem('clinicCountryZone') : 'Europe/London';
		var convertedDate = new Date(moment(selDate).local());
		console.log("+++booking++>>2", convertedDate)
		// for react calendar
		// var selDate = udatedDate.date;
		// for fullcalendar
		
		var userlocation = moment.tz.guess();
		var todayDate = `${convertedDate.getFullYear()}-${convertedDate.getMonth() + 1}-${convertedDate.getDate()}`
		var weekday = new Array("sunday", "monday", "tuesday", "wednesday",
		"thursday", "friday", "saturday");
		this.setState({
			appointmentDate: convertedDate,
			todayDate,
			dayToday: weekday[convertedDate.getDay()],
			
		})
		// var userlocation = 'Europe/London';
		localStorage.setItem('userlocation', userlocation);
		let availabilityId = localStorage.getItem('availabilityId');
		let patientId = localStorage.getItem('userId');
		let appointmentDate = convertedDate;
		// let today = moment().toString();
		var date = new Date();
		var offsetInHours = date.getTimezoneOffset() ;
		let appointmentObj = {
			availabilityId: availabilityId,
			appointmentDate: appointmentDate,
			clinetlocation: clinetlocation,
			userlocation: userlocation,
			selDate: selDate,
			specialistId: localStorage.getItem('specialistId'),
			timeZoneOffset: offsetInHours

		};
		this.props.actions.getSpecialistAvailability(appointmentObj, this.props);
		this.props.actions.getBlockAppointmentDate(appointmentObj, this.props);

	}

	Capitalize(str) {
		if (str != '' && str != undefined)
			return str.charAt(0).toUpperCase() + str.slice(1);
		else
			return '';
	}

	goToAppointmentDetailsPage(index, appointmentId) {
		this.setState({ spinner: index })
		if (localStorage.getItem('ReservedSlot') && localStorage.getItem('slot') != null) {

			localStorage.setItem('appointmentId', appointmentId);
			if (localStorage.getItem('ReservedSlot') != null && localStorage.getItem('ReservedSlot') == appointmentId) {

				window.location.href = constant.PRODUCTION_CURRENT_URL + 'dashboard/appointment-details'
				// history.push('/appointment-details');
			} else {
				if (localStorage.getItem('ReservedAvailability') == this.state.specialistAvailability.dayAvailability.availabilityId._id) {

					confirmAlert({
						title: 'Confirm',
						message: 'You already have a booking slot at ' + localStorage.getItem('slot') + '. If you click yes, that slot will be released and this new timeslot booked.  Click No to finish booking the original timeslot.',
						buttons: [
							{
								label: 'Yes',
								onClick: () => {
									localStorage.setItem('ReservedDoctorName', this.state.specialistDetailsCalendar.users ? this.Capitalize(this.state.specialistDetailsCalendar.users[0].firstName) + " " + this.Capitalize(this.state.specialistDetailsCalendar.users[0].lastName) : '')

									let appointmentDate = this.state.appointmentDate;
									let appointmentTime = this.state.specialistAvailability.finalSlot[index].slot;
									let availabilityId = localStorage.getItem('availabilityId');
									let patientId = localStorage.getItem('userId');
									let clinetlocation = localStorage.getItem('clinicCountryZone') ? localStorage.getItem('clinicCountryZone') : 'Europe/London';
									var userlocation = moment.tz.guess();
									// var userlocation = 'Europe/London';
									localStorage.setItem('userlocation', userlocation);
									let slotId = localStorage.setItem('slot', this.state.specialistAvailability.finalSlot[index].slot)
									let appointmentObj = {
										availabilityId: availabilityId,
										patientId: patientId,
										appointmentDate: appointmentDate,
										appointmentTime: appointmentTime,
										clinetlocation: clinetlocation,
										userlocation: userlocation
									};
									this.props.actions.bookAppointment(appointmentObj, this.props);
									let cancelAppointmentObj = {
										appointmentId: localStorage.getItem('ReservedSlot')
									}
									this.props.actions.cancelAppointment(cancelAppointmentObj, this.props);
								}
							},
							{
								label: 'No',
								onClick: () => {
									// history.push('/appointment-details');
									// window.location.href = constant.PRODUCTION_CURRENT_URL + 'appointment-details'+'/'+localStorage.getItem('ReservedSlot')
									let appointmentDate = localStorage.getItem('ReservedDate');
									let appointmentTime = localStorage.getItem('slot');
									let availabilityId = localStorage.getItem('availabilityId');
									let patientId = localStorage.getItem('userId');
									let clinetlocation = localStorage.getItem('clinicCountryZone') ? localStorage.getItem('clinicCountryZone') : 'Europe/London';
									var userlocation = moment.tz.guess();
									// var userlocation = 'Europe/London';
									localStorage.setItem('userlocation', userlocation);
									let slotId = localStorage.setItem('slot', this.state.specialistAvailability.finalSlot[index].slot)
									let appointmentObj = {
										availabilityId: availabilityId,
										patientId: patientId,
										appointmentDate: appointmentDate,
										appointmentTime: appointmentTime,
										clinetlocation: clinetlocation,
										userlocation: userlocation
									};
									this.props.actions.bookAppointment(appointmentObj, this.props);
									let cancelAppointmentObj = {
										appointmentId: localStorage.getItem('ReservedSlot')
									}
									this.props.actions.cancelAppointment(cancelAppointmentObj, this.props);
								}
							}
						]
					})

				} else {
					confirmAlert({
						title: 'Confirm',
						message: 'You already have a booking slot at ' + localStorage.getItem('slot') + ' with ' + localStorage.getItem('ReservedDoctorName') + '. If you click yes, that slot will be released and this new timeslot booked.  Click No to finish booking the original timeslot.',
						buttons: [
							{
								label: 'Yes',
								onClick: () => {
									localStorage.setItem('ReservedDoctorName', this.state.specialistDetailsCalendar.users ? this.Capitalize(this.state.specialistDetailsCalendar.users[0].firstName) + " " + this.Capitalize(this.state.specialistDetailsCalendar.users[0].lastName) : '')
									let appointmentDate = this.state.appointmentDate;
									let appointmentTime = this.state.specialistAvailability.finalSlot[index].slot;
									let availabilityId = localStorage.getItem('availabilityId');
									let patientId = localStorage.getItem('userId');
									let clinetlocation = localStorage.getItem('clinicCountryZone') ? localStorage.getItem('clinicCountryZone') : 'Europe/London';
									var userlocation = moment.tz.guess();
									// var userlocation = 'Europe/London';
									localStorage.setItem('userlocation', userlocation);
									let slotId = localStorage.setItem('slot', this.state.specialistAvailability.finalSlot[index].slot)
									let appointmentObj = {
										availabilityId: availabilityId,
										patientId: patientId,
										appointmentDate: appointmentDate,
										appointmentTime: appointmentTime,
										clinetlocation: clinetlocation,
										userlocation: userlocation
									};
									this.props.actions.bookAppointment(appointmentObj, this.props);
									let cancelAppointmentObj = {
										appointmentId: localStorage.getItem('ReservedSlot')
									}
									this.props.actions.cancelAppointment(cancelAppointmentObj, this.props);
								}
							},
							{
								label: 'No',
								onClick: () => {
									// history.push('/appointment-details');
									// window.location.href = constant.PRODUCTION_CURRENT_URL + 'appointment-details'+'/'+localStorage.getItem('ReservedSlot')
									let appointmentDate = localStorage.getItem('ReservedDate');
									let appointmentTime = localStorage.getItem('slot');
									let availabilityId = localStorage.getItem('ReservedAvailability');
									let patientId = localStorage.getItem('userId');
									let clinetlocation = localStorage.getItem('clinicCountryZone') ? localStorage.getItem('clinicCountryZone') : 'Europe/London';
									var userlocation = moment.tz.guess();
									// var userlocation = 'Europe/London';
									localStorage.setItem('userlocation', userlocation);
									let slotId = localStorage.setItem('slot', this.state.specialistAvailability.finalSlot[index].slot)
									let appointmentObj = {
										availabilityId: availabilityId,
										patientId: patientId,
										appointmentDate: appointmentDate,
										appointmentTime: appointmentTime,
										clinetlocation: clinetlocation,
										userlocation: userlocation
									};
									this.props.actions.bookAppointment(appointmentObj, this.props);
									let cancelAppointmentObj = {
										appointmentId: localStorage.getItem('ReservedSlot')
									}
									this.props.actions.cancelAppointment(cancelAppointmentObj, this.props);
								}
							}
						]
					})

				}


			}
		} else {
			let appointmentDate = this.state.appointmentDate;
			let appointmentTime = this.state.specialistAvailability.finalSlot[index].slot;
			let availabilityId = localStorage.getItem('availabilityId');
			let patientId = localStorage.getItem('userId');
			let clinetlocation = localStorage.getItem('clinicCountryZone') ? localStorage.getItem('clinicCountryZone') : 'Europe/London';
			var userlocation = moment.tz.guess();
			// var userlocation = 'Europe/London';
			localStorage.setItem('userlocation', userlocation);
			localStorage.setItem('slot', this.state.specialistAvailability.finalSlot[index].slot);
			let appointmentObj = {
				availabilityId: availabilityId,
				patientId: patientId,
				appointmentDate: appointmentDate,
				appointmentTime: appointmentTime,
				clinetlocation: clinetlocation,
				userlocation: userlocation
			};
			this.props.actions.bookAppointment(appointmentObj, this.props);
		}
	};

	render() {

		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath = user && user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';
		var specialistAvailabilitySlot = this.state.specialistAvailability ? this.state.specialistAvailability.finalSlot : this.state.specialistAvailability;
		var specialistDetailsCalendar = this.state.specialistDetailsCalendar;
		var appointmentIdtemp = 0;
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		return (
			<div className="content-wrapper">


				{this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :
					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom ipad-nav-custom">
										<ul className="nav nav-tabs">
											<li ><Link href="#tab_1" className="active show" data-toggle="tab">Calendar</Link></li>
											<li className=" col-md">
												<div className="content-header"><ol className="breadcrumb">
													<li><Link> Book Appointment</Link></li>
													<li><Link to="/book-appointment">Search Specialist</Link></li>
													<li className="active">Calendar</li>
												</ol></div>

											</li>
										</ul>
										<div className="row">
											<div className="col-md-12 col-lg-4 col-xl-3  col-sm- active">
												<div className="tab-content tabother  text-center">
													<div className="tab-pane active" >
														{specialistDetailsCalendar && specialistDetailsCalendar.specialists ? <div className="box-body box-profile">
															<div className="profile-img-round">

																{specialistDetailsCalendar.specialists.profileImage == constant.DEFAULT_USER_IMAGE ? <img className="profile-user-img img-responsive img-circle" src={specialistDetailsCalendar.users[0].gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png'
																} alt="User profile picture" onError={(e) => { e.target.src = defaultImagePath }} /> : <img className="profile-user-img img-responsive img-circle" src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + specialistDetailsCalendar.users[0]._id + '/' + specialistDetailsCalendar.specialists.profileImage} alt="User profile picture" onError={(e) => { e.target.src = defaultImagePath }} />}


															</div>

															<h3 className="profile-username text-center text-capitalize">Dr.{specialistDetailsCalendar.users ? this.Capitalize(specialistDetailsCalendar.users[0].firstName) + " " + this.Capitalize(specialistDetailsCalendar.users[0].lastName) : ''}</h3>
															<h4 className="profile-dr text-center">{specialistDetailsCalendar.specializations ? specialistDetailsCalendar.specializations.specialization : ''}</h4>


															<p style={{ fontSize: 20 }}><StarRatingComponent
																name="rate2"
																editing={false}
																starCount={5}
																emptyStarColor={'#D3D3D3'}
																renderStarIcon={(index, value) => {
																	return (
																		<span>
																			{index <= value ? <span><img src={require('../../images/start_icon.png')} /></span> : <span><img src={require('../../images/start_icon_off.png')} /></span>}
																		</span>
																	);
																}}
																value={specialistDetailsCalendar.averageRating}
															/>
															</p>
															<p>{specialistDetailsCalendar.reviewCount} Reviews</p>
															<Link>		{specialistDetailsCalendar.mobileNo ? <p><i className="fa"><img src={require('../../images/img/telephone.png')} /></i> 	{specialistDetailsCalendar.phoneCode1} - {specialistDetailsCalendar.mobileNo}
															</p> : ''}</Link>
															{specialistDetailsCalendar.telephoneNo ? <p>
																<i className="fa"><img src={require('../../images/img/phone_input_icon.svg')} /></i><Link> {specialistDetailsCalendar.phoneCode2} - {specialistDetailsCalendar.telephoneNo}</Link>
															</p> : ''}
															<p>
																<i className="fa marginbottom10 "><i className="fa fa-map-marker"></i></i>
																<div className="capitalize" style={{ 'wordBreak': 'break-all', 'font-size': '11px' }}>
																	<p>{specialistDetailsCalendar ? specialistDetailsCalendar.clinicName : ''},</p>
																	<p>{specialistDetailsCalendar ? specialistDetailsCalendar.addressLineOne : ''},</p>
																	<p>{specialistDetailsCalendar ? specialistDetailsCalendar.city : ''},</p>
																	<p>{specialistDetailsCalendar ? specialistDetailsCalendar.state : ''},</p>
																	<p>{specialistDetailsCalendar ? specialistDetailsCalendar.country : ''},</p>
																	<p>{specialistDetailsCalendar ? specialistDetailsCalendar.zipCode : ''}</p>

																</div>
															</p>


														</div> : ''}

													</div>

												</div>
											</div>
											<div className="col-md-12 col-lg-8 col-xl-9">
												<div className="tab-content tabother">
													{/* <FullCalendar 
													defaultView="dayGridMonth"
													header={{
														left: 'prev,next today',
														center: 'title',
														right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
													}}
													value={this.state.appointmentDate}
													plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
													minTime={new Date()}
													dateClick={this.onChange.bind(this)}
													
													/> */}
													<Calendar value={this.state.appointmentDate} onChange={this.onChange.bind(this)} minDate={this.state.minDate} />

													<div className="table-responsive">
														<table className="table table-condensed calendarRow table-hover">
															<tbody>
																{(specialistAvailabilitySlot && specialistAvailabilitySlot.length > 0) ? specialistAvailabilitySlot.map((item, index) => {
																	let reservedAppointmentID = localStorage.getItem('userId') && item.appointmentStatus == 5 ? localStorage.setItem('ReservedSlot', item.appointmentId) : ''

																	let reservedAppointmentDate = localStorage.getItem('userId') && item.appointmentStatus == 5 ? localStorage.setItem('ReservedDate', item.checkappointmentDate) : ''
																	let reservedDoctorName = localStorage.getItem('userId') && item.appointmentStatus == 5 && !localStorage.getItem('ReservedDoctorName') ? localStorage.setItem('ReservedDoctorName', specialistDetailsCalendar && specialistDetailsCalendar.users ? specialistDetailsCalendar.users[0].userName : "") : '';
																	let reservedAvailability = localStorage.getItem('userId') && item.appointmentStatus == 5 ? localStorage.setItem('ReservedAvailability', this.state.specialistAvailability ? this.state.specialistAvailability.dayAvailability.availabilityId._id : '') : '';


																	return (
																		//	appointmentIdtemp = item.appointmentId ? item.appointmentId : 0,
																		<tr key={index}>
																			<td style={{ width: 60 }}><i className="fa fa-check-circle checkGray"></i></td>

																			<td className="timeDate">	{item.slot + " " + userlocation}
																				{/* <Moment add={{ hours: 1 }}>{item.slot}</Moment> */}
																			</td>
																			<td><i className="fa marginbottom10"><i className="fa fa-map-marker"></i>  </i>
																				<p className="capitalize">{specialistDetailsCalendar ? specialistDetailsCalendar.addressLineOne : ''}, {specialistDetailsCalendar ? specialistDetailsCalendar.addressLineTwo : ''}<br />
																					{specialistDetailsCalendar ? specialistDetailsCalendar.city : ''},    {specialistDetailsCalendar ? specialistDetailsCalendar.state : ''}, {specialistDetailsCalendar ? specialistDetailsCalendar.country : ''}<br />
																					{specialistDetailsCalendar ? specialistDetailsCalendar.zipCode : ''}
																				</p>
																			</td>
																			{
																				item.status == 1 ?

																					<td>
																						{
																							((item.userid == localStorage.getItem('userId') && item.appointmentStatus == 5)) ?
																								<button type="button" className="btn btn-block btn-success bookNowBtn"
																									onClick={this.goToAppointmentDetailsPage.bind(this, index, item.appointmentId ? item.appointmentId : 0)}>Reserved {this.state.spinner == index ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
																								// <button type="button" className="btn btn-block btn-warning bookNowBtn"
																								// 	onClick={this.goToAppointmentDetailsPage.bind(this, index)}>Book Now</button>
																								:

																								<button type="button" className="btn btn-block btn-default bookNowBtn">Not Available</button>}


																					</td>
																					: (this.state.specialistBlockTimes && this.state.specialistBlockTimes.indexOf(item.slot) > -1 ?
																						// || this.state.specialistBlockDates.indexOf(this.state.todayDate) > -1 
																						// || this.state.specialistBlockDays.indexOf(this.state.dayToday) > -1 ?
																						<td>
																							<button type="button" className="btn btn-block btn-default bookNowBtn">Not Available</button>
																						</td>
																						:
																						<td >
																							<button type="button" className="btn btn-block btn-warning bookNowBtn" disabled={this.state.spinner == index ? true : false}
																								onClick={this.goToAppointmentDetailsPage.bind(this, index, appointmentIdtemp, item)}>Book Now {this.state.spinner == index ? <i className="fa fa-spinner fa-spin" /> : ""}  </button>
																						</td>)
																			}
																		</tr>)
																}) : <tr className="text-center"><td><h5>Specialist not available for the selected day.</h5></td></tr>}
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				}

				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		specialistAvailability: state.appointment.specialistAvailability,
		appointmentDetails: state.appointment ? state.appointment.appointmentDetails : [],
		specialistDetailsCalendar: state.appointment.specialistDetailsCalendar,
		specialistBlockDates: state.appointment ? state.appointment.specialistBlockedDates : []
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(BookAppointmentCalendar);
